import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import {
  multipleEmailValidation,
  PasswordValidationCallbacks,
  RealNameValidationCallbacks,
} from '@/services/misc/functions/ValidationFunctions';

export default class CreateMailboxUserForm {
  public mailboxId: number = -1;
  public address: string = '';
  public password: string = '';
  public realName: string = '';
  public aliases: string[] = [];
  public forwards: string[] = [];

  public rules: { [name: string]: FormValidationFunction[] } = {
    mailboxId: [
      (v: number) => !!v || 'Mailbox is required!',
    ],
    address: [
      (v: string) => v.length >= 3 || 'Valid address is required!',
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks,
    ],
    realName: RealNameValidationCallbacks,
    aliases: [
      (v: string[]) =>
        !v ||
        !v.length ||
        v.every((val) => (val) && /^(?:|[A-Za-z0-9.-]{3,})@[A-Za-z0-9.-]{3,}\.[A-Za-z.-]{2,3}$/.test(val)) ||
        'Aliases must be valid email addresses',
    ],
    forwards: [
      ...multipleEmailValidation('Forwards must be valid email addresses'),
    ],
  };
}
